import * as Sentry from "@sentry/react";
import {HttpClient} from "@sentry/integrations";

import Timeline from "./components/timeline.jsx";

window.waffle = require('../../../waffle/static/scripts/waffle.jsx');
window.yoco = require('../../../waffle/static/scripts/yoco/yoco.jsx');
window.misc = require('../../../waffle/static/scripts/components/misc.jsx');

module.exports = {
  addresses: require('./components/addresses.jsx'),
  buttons: require('./components/buttons.jsx'),
  filters: require('./components/filters.jsx'),
  orders: require('./components/orders.jsx'),
  simCards: require('./components/simCards.jsx'),
  businesses: require('./components/businesses.jsx'),
  transactions: require('./components/transactions.jsx'),
  exceptions: require('./components/exceptions.jsx'),
  risk: require('./components/risk.jsx'),
  vetting: require('./components/vetting.jsx'),
  logFiles: require('./components/logFiles.jsx'),
  logFetcher: require('./components/logFetcher.jsx'),
  auditLog: require('./components/auditLog.jsx'),
  updateRequests: require('./components/updateRequests.jsx'),
  cardReaders: require('./components/cardReaders.jsx'),
  logisticsBulkUpdate: require('./components/logisticsBulkUpdate.jsx'),
  inlineExceptions: require('./components/inlineExceptions.jsx'),
  performedRiskActions: require('./components/performedRiskActions.jsx'),
  authenticator: require('./components/authenticator.jsx'),
  Timeline: Timeline,
  utils: require('./utils.jsx'),
  refunds: require('./components/refunds.jsx'),
  editUserHeader: require('./components/editUserHeader.jsx'),
  redirectHandler: require('./components/redirectHandler.jsx'),
  payouts: require('./components/payouts.jsx'),
  sumsub: require('./components/sumsub.jsx'),
  pockets: require('./components/pockets.jsx'),
};

Sentry.init({
    dsn: 'https://a9573561e0e04a568284f460dd51b568@o406491.ingest.sentry.io/6070052',
    environment: process.env.SENTRY_ENVIRONMENT || 'development',
    release: process.env.SENTRY_RELEASE || 'dev',
    tracesSampleRate: process.env.SENTRY_TRACE_SAMPLE_RATE || 0.1,
    tracePropagationTargets: ['localhost', /^\//, /^\?ajax=true/],
    sendDefaultPii: true,
    integrations: [
        new Sentry.BrowserTracing({
            _experiments: { enableInteractions: true, enableHTTPTimings: true },
            beforeNavigate: context => {
                return {
                    ...context,
                    name: location.pathname
                        .replace(/\/([0-9]{13}-)?[A-Fa-f0-9]{8}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{12}/g, "/:uuid"),
                };
            },
        }),
        new HttpClient(),
    ],
});

window.admin = module.exports;
